import * as springroll from "springroll";
import {GoogleAnalytics} from "springroll-google-analytics-plugin";
import {Application} from "../Application";

export class Analytics {

    public static event(action: string, label?: string, value?: number) {
        const analytics = Application.instance.springroll.getPlugin("GoogleAnalytics") as (GoogleAnalytics & springroll.ApplicationPlugin);
        if (analytics) {
            analytics.event("Friends Around The World", action, label, value);
        }
    }
}
